'use strict';

function NewVehicleController(
    $scope,
    $mdDialog,
    initialPlate,
    VehiclesService
) {
    'ngInject';

    $scope.model = {
        plate: initialPlate.toUpperCase(),
        number: '',
        description: ''
    };
    $scope.btnDisabled = true;

    $scope.clearValidity = function() {
        $scope.form.plate.$setValidity('already-exists', true);
        $scope.form.number.$setValidity('already-exists', true);
    };

    $scope.onNumberChange = function() {
        $scope.clearValidity();
    };

    $scope.onPlateChange = function() {
        $scope.clearValidity();
        $scope.model.plate = $scope.model.plate.trim().toUpperCase();
    };

    $scope.save = function() {
        if ($scope.form.$valid) {
            let vehicle = VehiclesService.create($scope.model);
            VehiclesService.save(vehicle).then(vehicle => {
                $mdDialog.hide({
                    vehicle: vehicle
                });
            }, err => {
                console.debug(err);
                let error = err.data && err.data.error;
                let alreadyExists = error &&
                    error.code == 'CLIENT_ALREADY_EXISTS';
                $scope.form.plate.$setValidity('already-exists', false);
                $scope.form.number.$setValidity('already-exists', false);
            });
            
        }
    };

    $scope.cancel = function() {
        $mdDialog.cancel();
    };
}

export default NewVehicleController;
